export const MerchantListItemActionFooterMessages = {
  selectButton: {
    id: 'Pages.MerchantSelection.MerchantListItem.selectButton',
    description: 'Select merchant list item select button'
  }
}
